// The doorway an anonymous visitor meets on a gated tab.
//
// This is the highest-intent moment on the public site: someone read the story,
// clicked into the product, and wants in. It used to answer with a policy
// notice ("Planning is behind the operator login"), which is true and sells
// nothing. It now makes the pitch and offers the two real doors.
//
// Honest wiring matters more than a bigger button: there is no self-serve
// signup yet, so the second action REQUESTS access by email rather than
// pretending an account is one click away. Swap it for a real signup route the
// day one exists — the label and href are the only things that change.
const ACCESS_MAILTO =
  'mailto:hello@xnapz.com' +
  '?subject=Early%20access%20to%20xnapz' +
  '&body=Tell%20me%20a%20little%20about%20the%20work%20you%27d%20point%20xnapz%20at%3A%0A%0A'

export function SignInGate({ tabLabel }: { tabLabel: string }) {
  return (
    <section className="signin-gate" aria-labelledby="signin-gate-title">
      <p className="signin-eyebrow">{tabLabel} needs an account</p>
      <h2 id="signin-gate-title">
        Put xnapz to work on your next job.
      </h2>
      <p className="signin-pitch">
        Whether you're running a business or starting the side hustle that
        becomes one, describe the job in a sentence — xnapz turns it into a
        plan, prices it from real cost data, and staffs it. You keep the
        judgment. It does the paperwork.
      </p>

      <ul className="signin-points">
        <li>
          <strong>Priced, not guessed.</strong> Labor from public wage data,
          materials from published contracts — and an honest “needs a quote”
          where it can't ground a number.
        </li>
        <li>
          <strong>Plans that hold up.</strong> Tasks, dependencies, and the
          questions a good estimator asks before quoting.
        </li>
        <li>
          <strong>Work that routes itself.</strong> AI where it earns its
          place, your people where they should own it.
        </li>
      </ul>

      <div className="signin-actions">
        <a className="gate-btn primary" href="/api/login">
          Log in
        </a>
        <a className="gate-btn" href={ACCESS_MAILTO}>
          Request access
        </a>
        <a className="gate-btn ghost" href="#/story">
          Back to the story
        </a>
      </div>
    </section>
  )
}
